module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "principle-addition column is-one-third is-pulled-left"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deletePrinciple(_vm.principle.id)
      }
    }
  }), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updatePrinciple(_vm.principle)
      }
    },
    model: {
      value: (_vm.principle.title),
      callback: function($$v) {
        _vm.$set(_vm.principle, "title", $$v)
      },
      expression: "principle.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updatePrinciple(_vm.principle)
      }
    },
    model: {
      value: (_vm.principle.description),
      callback: function($$v) {
        _vm.$set(_vm.principle, "description", $$v)
      },
      expression: "principle.description"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62dd432d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/Principle.vue
// module id = 956
// module chunks = 0